import { type TypedUseSelectorHook,useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';

/** Typed `useDispatch`: knows about thunk/saga-dispatchable actions. */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/** Typed `useSelector` bound to the app's RootState. */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
